import {
  OfferConditionTypeEnumV2,
  OfferDiscountTypeEnumV2,
  type SellerPromotionV2,
} from '@redteclab/api/clients/bully'

export const productAccessorOfferHasFreeItemSellerPromotion = (
  sellerPromotion: SellerPromotionV2,
): boolean =>
  sellerPromotion.conditionType ===
    OfferConditionTypeEnumV2.MinimumSameItemQuantity &&
  sellerPromotion.discountType === OfferDiscountTypeEnumV2.FreeItems
